import { Component, Input, TemplateRef, Type, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { TooltipContent } from './tooltip-content.type';

@Component({
  selector: 'suka-tooltip',
  template: `
    <div @tooltip class="tooltip tooltip-{{position}}">
      <span class="tooltip__caret"></span>
      <ng-container [ngSwitch]="renderMethod">
        <div *ngSwitchCase="'text'" [innerHTML]="content"></div>
        <ng-container *ngSwitchCase="'template'">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'component'">
          <ng-container *ngComponentOutlet="content"></ng-container>
        </ng-container>
      </ng-container>
    </div>`,
  animations: [
    trigger('tooltip', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.2s ease-in', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate(200, style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class TooltipContainer implements OnInit {
  public renderMethod: 'template' | 'component' | 'text' = 'component';

  @Input() content: TooltipContent;
  @Input() position: 'top' | 'bottom' | 'right' | 'left' = 'bottom';

  ngOnInit() {
    if (typeof this.content === 'string') {
      this.renderMethod = 'text';
    }

    if (this.content instanceof TemplateRef) {
      this.renderMethod = 'template';
    }
  }
}
